module.exports = __webpack_public_path__ + "static/img/024干部作风大整顿1.e6007ad.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/picImgs/024干部作风大整顿1.jpg
// module id = FerC
// module chunks = 0